import { styled, Typography } from '@mui/material';

interface AutocompleteLabelProps {
  label?: string;
}

const StyledAutocompleteLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  textTransform: 'uppercase',
  lineHeight: '16px',
  fontWeight: 400,
  color: theme.hhglobal.purpose.textWeak,
}));

function AutocompleteLabel(props: AutocompleteLabelProps) {
  return props.label && <StyledAutocompleteLabel>{props.label}</StyledAutocompleteLabel>;
}

export default AutocompleteLabel;
